import React from "react";
import { bool, string, func, object, oneOfType } from "prop-types";
import DatePicker from "react-datepicker";
import { format, addYears, subDays, addDays } from "date-fns";
import { GetIcon } from "../icons/GetIcon.js";

const DateFacets = (props) => {
  const { endDate, id, showLabel, startDate, handleUpdate } = props;

  let currentDate = startDate;

  const handleChangeStart = (date) => {
    currentDate = date;
  }

  const handleClose = () => {
    if(currentDate === startDate) {
      return;
    }
    const date = currentDate;
    const newStartDateUTC = date instanceof Date ? format(new Date(date), "yyyy-MM-dd") : null;

    const newEndDateUTC = date instanceof Date ? format(subDays(addYears(new Date(date), 1), 1), "yyyy-MM-dd") : null;
    
    handleUpdate({
      endDate: newEndDateUTC,
      startDate: newEndDateUTC && newStartDateUTC > newEndDateUTC ? newEndDateUTC : newStartDateUTC
    });
  }

  // not sure why we have to add a day here
  let selectedStart = startDate ? addDays(new Date(startDate), 1) : null;

  return (
    <div className="facets__date">
      {showLabel && <div className="facets__date-visual-label">Year: </div>}
      <div className="form__field">
        <label htmlFor={id + "startfield"}><span className="visually-hidden">Start</span></label>
        <DatePicker
          showYearPicker={true}
          dateFormat="yyyy"
          id={id + "startfield"}
          onChange={handleChangeStart}
          onCalendarClose={handleClose}
          placeholderText="YYYY"
          autoComplete="off"
          selected={selectedStart} />
        {GetIcon("calendar")}
      </div>
    </div>
  );
}

DateFacets.propTypes = {
  endDate: oneOfType([object, string]),
  handleUpdate: func,
  id: string,
  startDate: oneOfType([object, string]),
  showLabel: bool
};

export default DateFacets;
